import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-gray-900/50 border-t border-gray-800/50 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center text-white font-bold text-sm">
                K
              </div>
              <span className="font-bold text-gray-400">K.I.T.BOT</span>
            </Link>
            <div className="hidden sm:flex items-center gap-4 text-sm text-gray-500">
              <Link to="/docs" className="hover:text-gray-300 transition-colors">Docs</Link>
              <Link to="/forum" className="hover:text-gray-300 transition-colors">Forum</Link>
              <Link to="/leaderboard" className="hover:text-gray-300 transition-colors">Leaderboard</Link>
            </div>
          </div>
          
          <div className="text-center md:text-right">
            <p className="text-gray-500 text-sm">
              🎬 Powered by{' '}
              <a 
                href="https://youtube.com/@traderlifestyle" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-cyan-400 hover:text-cyan-300 transition-colors"
              >
                TRADERLIFESTYLE
              </a>
            </p>
            <p className="text-gray-600 text-xs mt-1">
              © 2026 K.I.T.BOT.FINANCE - The AI Trading Community
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
